import React from "react";
import { ArmyUnit } from "../../../../lib/types";
import ArmyUnitAttributeLine from "./ArmyUnitAttributeLine";

import { armyUnits } from "../../../../assets/images/army";

interface IProps {
  unit: ArmyUnit,
  picture: string,
}

const ArmyUnitInfo = ({
  unit,
  picture
}: IProps) => (
  <>
    <h3 className="name">{unit.name}</h3>
    <img src={armyUnits[`army${picture}`]} width={"126"} height={"126"} alt="" />
    <ArmyUnitAttributeLine
      attributes={[
        {
          icon: "utok",
          title: "Attack",
          content: "attack power, ability to hit",
          value: unit.attributes.attack
        },
        {
          icon: "obrana",
          title: "Defence",
          content: "defense power, ability to block hits",
          value: unit.attributes.defence
        },
        {
          icon: "piercing",
          title: "Piercing",
          content: "ability to overcome armor",
          value: unit.attributes.piercing
        },
        {
          icon: "armor",
          title: "Armor",
          content: "reduces damage by 25% unless it’s pierced",
          value: unit.attributes.armor
        }
      ]}
    />
    <ArmyUnitAttributeLine
      attributes={[
        {
          icon: "ranged-attack",
          title: "Ranged Attack",
          content: "ranged attack power, ability to hit targets in range phase",
          value: unit.attributes.rangedAttack
        },
        {
          icon: "range",
          title: "Range",
          content: "distance from which the unit engages in range phase",
          value: unit.attributes.range
        },
        {
          icon: "dalsi-tah-5",
          title: "Charge",
          content: "force of initial attack",
          value: unit.attributes.charge
        },
        {
          icon: "dalsi-tah-6",
          title: "Speed",
          content: "adaptability and mobility of unit",
          value: unit.attributes.speed
        }
      ]}
    />
    <ArmyUnitAttributeLine
      attributes={[
        {
          icon: "totem",
          title: "Stamina",
          content: "endurance of unit during the battle",
          value: unit.attributes.stamina
        },
        {
          icon: "armada",
          title: "Morale",
          content: "mental resistance to damage",
          value: unit.attributes.morale
        },
        {
          icon: "hit-points",
          title: "Hit Points",
          content: "hit points, physical resistance to damage",
          value: unit.attributes.hp
        }
      ]}
    />
  </>
)

export default ArmyUnitInfo;
